import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import ChannelItemManagement from "./ChannelItemManagement";

const ChannelManagement: React.FC<{
  onClose: () => void;
  saveChannels: (channels: any) => void;
}> = ({ onClose, saveChannels }) => {
  const originalChannelList = useSelector(
    (state: any) => state.properties.channelList
  );

  const [list, setList] = useState([...originalChannelList.slice(1)]);

  const createChannel = () => {
    let newChannel: any = {
      name: "Nuevo canal",
      color: "red",
      key: null,
      action: "Create",
      timestamp: Date.now(),
      selected: false
    };
    setList([...list, newChannel]);
  };

  const handleConfirm = async () => {
    const channelsToSave = list.filter((channel) => channel.action != "None");
    await saveChannels(channelsToSave);
  };

  const updateList = (updatedChannel: any, index: number) => {
    const updatedList = list.map((channel, i) =>
      i === index ? { ...channel, ...updatedChannel } : channel
    );
    setList(updatedList);
  };

  const deleteChannel = (timestamp: number) => {
    setList((prevList) =>
      prevList.filter((channel) => channel.timestamp !== timestamp)
    );
  };

  return (
    <div className="modal">
      <div className="modal-body">
        <div className="modal-header">
          <h3>Administrar canales</h3>
          <button className="create-channel-btn" onClick={createChannel}>
            + Crear Canal
          </button>
        </div>
        <div className="modal-content">
          {list.map(
            (channel, index) =>
              channel.action !== "Delete" && (
                <ChannelItemManagement
                  key={channel.key || channel.timestamp}
                  index={index}
                  channel={channel}
                  updateList={updateList}
                  deleteChannel={deleteChannel}
                />
              )
          )}
        </div>
        <div className="modal-footer">
          <button className="cancel btn-footer" onClick={onClose}>
            Cancelar
          </button>
          <button className="confirm btn-footer" onClick={handleConfirm}>
            Confirmar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChannelManagement;
